import React from 'react';

const PATHS = {
  dashboard: 'M4 4h7v7H4zM13 4h7v4h-7zM13 10h7v10h-7zM4 13h7v7H4z',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  cards: 'M4 7h16v12H4zM4 11h16',
  tag: 'M20 13l-7 7-9-9V4h7zM7 7h.01',
  groups: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  receipt: 'M6 3h12v18l-2-1.5L14 21l-2-1.5L10 21l-2-1.5L6 21zM9 8h6M9 12h6',
  truck: 'M3 7h11v8H3zM14 10h4l3 3v2h-7zM7 18a2 2 0 1 0 0.01 0M17 18a2 2 0 1 0 0.01 0',
  wallet: 'M3 7h18v12H3zM3 10h18M16 14h3',
  lock: 'M7 11V8a5 5 0 0 1 10 0v3M6 11h12v10H6z',
  history: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5',
  chart: 'M4 19V5M4 19h16M8 16v-5M12 16V8M16 16v-3',
  bank: 'M4 10h16M6 10v8M10 10v8M14 10v8M18 10v8M3 18h18M12 3l9 7H3z',
  cheque: 'M3 7h18v10H3zM3 11h18M7 15h4',
  card: 'M3 6h18v12H3zM3 10h18',
  box: 'M3 8l9-4 9 4-9 4zM3 8v8l9 4 9-4V8M12 12v8',
  calendar: 'M5 5h14v14H5zM5 9h14M9 3v4M15 3v4',
  message: 'M4 5h16v10H7l-3 3z',
  settings: 'M12 8a4 4 0 1 0 0.01 0M4 12h2M18 12h2M12 4v2M12 18v2',
  shield: 'M12 3l8 3v6c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V6z',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0',
  audit: 'M8 4h8v4H8zM6 8h12v12H6zM9 12h6M9 16h4',
  backup: 'M12 4v10M8 10l4 4 4-4M5 20h14',
  logout: 'M10 7V5h10v14H10v-2M4 12h10M7 9l-3 3 3 3',
};

export function NavIcon({ name }) {
  const d = PATHS[name] || PATHS.list;
  return (
    <svg className="nav-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  );
}
